module.exports = __webpack_public_path__ + "img/free09_800x400.a394aef5.jpg";